import BlankCart from '@components/blank/BlankCart';
import CtaLayout from '@components/CtaLayout';
import Header from '@components/Header';
import Loading from '@components/Loading';
import useCart from '@hooks/cart/useCart';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import usePrepareWithCart from '@store/cart/hooks/usePrepareWithCart';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import CartFooter from './components/CartFooter';
import CartItems from './components/CartItems';
import CartNote from './components/CartNote';
import ShopLocation from './components/ShopLocation';

interface Params {
    shopId: string
}

const CartActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
    const { shopId } = params;
    const { isFetching, cart, isBlank } = useCart(shopId);
    const { t } = useTranslation('cart');
    usePrepareWithCart(shopId);
    return (
        <AppScreen>
            <CtaLayout header={<Header title={t('header.title')} />}
                footer={<CartFooter/>} >
                <ShopLocation/>
                {cart && (
                    <Fragment>
                        <CartItems shopId={shopId} cartId={cart.cartId} />
                        <CartNote/>
                    </Fragment>
                )}
                {isBlank && (<BlankCart/>)}
                {isFetching && <Loading size='small' /> }
            </CtaLayout>
        </AppScreen>
    );
};

export default CartActivity;
